import type { DomainMapper } from '../types';

// TODO: Backend team should create a dedicated applicationId for corporate domains.

const corporateSe: DomainMapper = {
  countryCode: 'corporate-se',
  currency: 'GBP',
  domain: 'localhost:3011',
  environment: 'local',
  flagUrl: '/flags/1x1/SE.svg',
  languagePrimary: true,
  locale: 'sv',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-uk.xml',
  storyblokBasePath: 'sv-se',
  url: 'https://localhost:3011/sv-se',
  applicationId: 1156, // stage — reusing SE until dedicated corporate applicationId exists
  // applicationId: 1155, // prod
  subFolder: true,
  googleSiteVerification: '_khK6fTW4MrMqgixPOHH37F9BD7VJNkk3JXdFUMZthA',

  features: {
    fastOrder: false,
    backorders: false,
    cartSettings: false,
    nonEcomSite: true,
    cisionLanguage: 'sv',
  },
} as DomainMapper;

export default corporateSe;
